import { Views } from '@singularsystems/neo-react';
import { AppService, DomainTypes, Types } from '../../../DomainTypes';
import { DateUtils, List } from "@singularsystems/neo-core";
import { InvestorInvestmentNoticeRequest } from "../../../Models/InvestorInvestments/InvestorInvestmentNoticeRequest";
import { ActionType } from "../../../Models/InvestorInvestments/Commands/ActionNoticeRequest";
import InvestorInvestmentVM from "../InvestorInvestmentVM";
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";

export default class NoticeComponentVM extends Views.ViewModelBase {

    constructor(
        private parentVM: InvestorInvestmentVM,
        taskRunner = parentVM.taskRunner,
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        public apiClient = AppService.get(DomainTypes.ApiClients.InvestorInvestmentNotice)) {

        super(taskRunner);
        this.makeObservable();
    }

    private investorInvestmentId: number | null = null;

    public fromDate: Date = DateUtils.today();

    public notices = new List(InvestorInvestmentNoticeRequest);

    public processAction: InvestorInvestmentNoticeRequest | null = null;

    public async initialise() {
        
    }

    public reset() {
        this.investorInvestmentId = null;
    }

    public async ensureInitialised(investorInvestmentId: number) {
        if (this.investorInvestmentId !== investorInvestmentId) {
            this.investorInvestmentId = investorInvestmentId;
            
            await this.fetchNotices();
        }
    }

    public async fetchNotices() {
        if (this.investorInvestmentId) {
            const notices = await this.taskRunner.waitForData(this.apiClient.getNotices(this.investorInvestmentId, this.fromDate));
            this.notices.set(notices);
        }
    }

    public async actionNotice(notice: InvestorInvestmentNoticeRequest, type: ActionType) {
        return this.taskRunner.run(async () => {
            const result = await this.apiClient.actionNoticeRequest({
                investorInvestmentNoticeRequestId: notice.investorInvestmentNoticeRequestId,
                action: type,
            });

            if (type === ActionType.Cancel) {
                notice.cancelled.set(result.data);
            } else {
                notice.actioned.set(result.data);
                notice.lookup.actionedBy = "You";
            }

            if (this.parentVM.investorInvestment) {
                const investmentResult = await this.parentVM.investorInvestmentsApiClient.getInvestorInvestment(this.parentVM.investorInvestment.investorInvestmentId);
                this.parentVM.investorInvestment.set(investmentResult.data);
            }

            this.notifications.addSuccess("Notice Request", "Notice actioned successfully.", NotificationDuration.Standard);
        });
    }

    public async authoriseNotice(notice: InvestorInvestmentNoticeRequest) {

        const result = await this.taskRunner.run(() => this.apiClient.authoriseNoticeRequest(notice.investorInvestmentNoticeRequestId));
        notice.authorised.set(result.data);

        this.notifications.addSuccess("Authorise", "Notice authorised successfully.", NotificationDuration.Standard);
    }
}